import { render, staticRenderFns } from "./hint.vue?vue&type=template&id=3c88ce6c&scoped=true&"
import script from "./hint.vue?vue&type=script&lang=js&"
export * from "./hint.vue?vue&type=script&lang=js&"
import style0 from "./hint.vue?vue&type=style&index=0&id=3c88ce6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c88ce6c",
  null
  
)

export default component.exports